import { appendAPExamTemplate } from '@/functions/idp'
import RIC from './RIC_11'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
